import React from 'react';
import { DashboardShell, TileSection, listCount, useRefreshKey, useAnyVisible } from '../../shared/LiveDashboard';
import { todayInTenant } from '../../shared/tenantClock';

// Receivables Dashboard: a live starter (shared/LiveDashboard.js).
const monthStart = () => `${todayInTenant().slice(0, 8)}01`;
const invoicesFrom = (from) => ({ status: 'open', date_from: from, date_to: todayInTenant() });
const receiptsFrom = (from) => ({ status: 'recorded', date_from: from, date_to: todayInTenant() });

const INVOICES = [
  {
    key: 'invoices-month',
    label: 'Invoices This Month',
    screen: 'receivables-invoices',
    icon: 'Outstanding Invoices',
    count: () => listCount('/api/invoices', { ...invoicesFrom(monthStart()), limit: 1 })(),
    to: '/receivables-invoices',
    get state() { return { initialFilters: invoicesFrom(monthStart()) }; },
  },
  {
    key: 'invoices-void',
    label: 'Voided Invoices',
    screen: 'receivables-invoices',
    icon: 'Outstanding Invoices',
    count: listCount('/api/invoices', { status: 'void', limit: 1 }),
    to: '/receivables-invoices',
    state: { initialFilters: { status: 'void' } },
  },
];

const RECEIPTS = [
  {
    key: 'receipts-month',
    label: 'Receipts This Month',
    screen: 'receivables-receipts',
    icon: 'Receipts',
    count: () => listCount('/api/receipts', { ...receiptsFrom(monthStart()), limit: 1 })(),
    to: '/receivables-receipts',
    get state() { return { initialFilters: receiptsFrom(monthStart()) }; },
  },
];

function ReceivablesDashboard() {
  const [refreshKey, refresh] = useRefreshKey();
  const any = useAnyVisible(INVOICES, RECEIPTS);
  return (
    <DashboardShell
      title="Receivables Dashboard"
      description={any ? 'Invoices and Receipts this month.' : 'Your Roles don’t include any of this dashboard’s cards.'}
      onRefresh={refresh}
    >
      <TileSection title="Invoices" tiles={INVOICES} refreshKey={refreshKey} />
      <TileSection title="Receipts" tiles={RECEIPTS} refreshKey={refreshKey} />
    </DashboardShell>
  );
}

export default ReceivablesDashboard;
